import React, { useEffect, useState } from 'react'
import Carousel  from 'react-bootstrap/Carousel'
import 'bootstrap/dist/css/bootstrap.min.css'
import ban1 from '../images/ban1.jpg'
import ban2 from '../images/ban2.jpg'
import ban3 from '../images/ban3.jpg'
import ban4 from '../images/ban4.webp'
import ban234 from '../images/mobile/ban234.jpg'
import ban334 from '../images/mobile/ban334.jpg'
import ban434 from '../images/mobile/ban434.jpg'






export default function MyCarousal() {
  

  const desktopImages = [ban2, ban3, ban4];
  const mobileImages = [ban234, ban334, ban434]; // mobile versions

  const captions = [
    "Empowering businesses through innovative solutions",
    "Building partnerships for sustainable growth",
    "Transforming ideas into impactful results",
   
    // Add more captions as needed
  ];

  // filepath: c:\Users\Asus\Desktop\MZ\Mflip-Frontend\src\Components\MyCarousal.js



  return (
    <div className="full-screen-carousel" style={{ paddingTop: '100px' }}>
      
      <Carousel interval={3000} fade>
  {desktopImages.map((img, index) => (
    <Carousel.Item key={index}>
      <picture>
        <source media="(max-width: 768px)" srcSet={mobileImages[index]} />
        <img className="d-block w-100 img-fluid" src={img} alt={`Slide ${index + 1}`} />
      </picture>
      <Carousel.Caption>
        <h3 className="word-outline">{captions[index]}</h3>
      </Carousel.Caption>
    </Carousel.Item>
  ))}
</Carousel>

    </div>
  );
};